import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/media.svg';
import { ReactComponent as IconSvg2 } from '@/images/icons/media_white.svg';
const MediaSvg = () => React.createElement(IconSvg, null);
export const MediaWhiteSvg = () => React.createElement(IconSvg2, null);
export default MediaSvg;
